import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/auth.service';
import { UserDataService } from 'src/app/services/user-data-service';
import { OrganizationService } from '../../organization/organization.service';
import { Organization } from 'src/app/services/organization.model';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogConfig } from '@angular/material/dialog';
import { SelectOrganizationDialogComponent } from '../../organization/select-organization-dialog/select-organization-dialog.component';
import { OrganizationWarningDialogComponent } from '../../organization/organization-warning-dialog/organization-warning-dialog.component';
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loading: boolean = false; // Loading indicator
  errorMessage: string | null = null; // To store error messages
  showPassword: boolean = false; // Password visibility toggle
  organizations: Organization[] = [];
  isDialogOpen = false;  // Flag to track if the dialog is open
  private remoteLoginSubscription: Subscription;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private userData: UserDataService,
    private organizationService: OrganizationService,
    private matDialog: MatDialog,
    private userDataService:UserDataService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      organization: [0] // Default organization to 0
    });
  }

  ngOnInit(): void {
    this.resetForm();
    // Covers two tabs both sitting on this form before either logs in: if a
    // DIFFERENT tab completes login while this one is still rendered, follow it
    // to /node immediately rather than letting this tab's own (now stale) form
    // stay up and risk submitting a second, different user's credentials.
    this.remoteLoginSubscription = this.authService.remoteLogin$.subscribe(() => {
      this.router.navigate(['/node']);
    });
  }

  ngOnDestroy(): void {
    this.remoteLoginSubscription?.unsubscribe();
  }

  // Reset form and clear any error messages
  resetForm(): void {
    this.loginForm.reset();
    this.errorMessage = null;
  }

  // Handle form submission
  async onSubmit(): Promise<void> {
    if (this.loginForm.valid) {
      const loginData = {
        ...this.loginForm.value
       // organization: this.loginForm.value.organization || 0 // Default organization to 0 if not chosen
      };
  
      this.loading = true; // Show loading indicator
    //  console.log("Login Data:", loginData);
  
      try {
        // Attempt to log in
        const response = await this.userService.onLogin(loginData);
        this.loading = false; // Hide loading indicator
  
        if (response.loginStatus) {
          //clear all localStorage values
          var darkMode = localStorage.getItem("theme-mode");
          // Safe to wipe stale state from a previous user now: LoginGuard only
          // lets this form render/submit when no session is already active on
          // this browser profile, so there's no other in-flight session whose
          // state this could clobber.
          this.userDataService.clear();
          localStorage.setItem("theme-mode",darkMode);
          // Successful login actions
          localStorage.setItem('userData', JSON.stringify(response));
          this.userDataService.setUserData(JSON.stringify(response)); // Using service method to store data in localStorage
          this.userDataService.setUserId(response.userId.toString());
         // localStorage.setItem('loginData', JSON.stringify(loginData));
          this.userData.setUserName(response.userName);
          this.authService.setLoginStatus(true); // Update login status

          // Fetch organizations using the userId
          const resorg = await this.userService.getUserById(response.userId);
          this.userDataService.setOrgData(JSON.stringify(resorg));
          localStorage.setItem('userOrgs', JSON.stringify(resorg.organization));
         // Check if there's exactly one organization
       if (resorg && resorg.organization && resorg.organization.length === 1) {
  const organizationId = resorg.organization[0].organizationId;
  resorg.organization[0].organizationId;
  localStorage.setItem('selectedOrganizationId', organizationId.toString());
  this.userDataService.setSelectedOrganization(organizationId);
  this.userDataService.setOrgId(organizationId.toString());
  this.organizationService.setSelectedOrganization(organizationId.toString());

  // ✅ Check roleId before passing to service
  if (resorg.organization[0].roleId !== undefined && resorg.organization[0].roleId !== null) {
    try {
      // Tells the server which org/role this session now acts under, so it
      // recomputes the session's sliding timeout from that org's admin-configured
      // value instead of the system default it was created with at credential check.
      await this.userService.selectOrganizationSession(organizationId, resorg.organization[0].roleId);

      const sessionResponse = await this.userService.getSessionTimeoutsByOrgRole(
        organizationId,
        resorg.organization[0].roleId
      ).toPromise();

      
      // Check if sessionResponse is an object (not array)
      if (sessionResponse && 'timeout' in sessionResponse) {
        const timeout = sessionResponse.timeout;
        this.userDataService.setUserSessionTimeoutData(timeout);
        this.sessionTimeoutService.start(); // ✅ start tracking inactivity
      } else if (Array.isArray(sessionResponse) && sessionResponse.length > 0) {
        const timeout = sessionResponse[0].timeout;
        this.userDataService.setUserSessionTimeoutData(timeout);
        this.sessionTimeoutService.start(); // ✅ start tracking inactivity
      } else {
        console.warn('No session timeout data found for this role.');
      }
      
    } catch (err) {
      console.error('Error fetching session timeouts:', err);
    }
  }
  
  else {
    console.warn('userType is missing in response:', response);
  }

  this.router.navigate(['/node']);
}
 else {
          // Handle the case where there are multiple organizations or no organizations
          if (resorg && resorg.organization && resorg.organization.length > 1) {
            // Show the popup if there are more than one organization
            this.OpenEntryDialog(resorg.organization,  response.userType);
          } else {
            // Handle the case where there are no organizations
            //console.warn('No organizations found.');
            //console.log("Selected Organization ID saved:", '0');
            this.OpenWarningDialog(resorg.organization,resorg);
           
           // this.router.navigate(['/node']);
          }
        }
        } else {
          this.errorMessage = 'Login failed. Please try again.';
        }
      } catch (error) {
        this.loading = false; // Hide loading indicator
        console.error('Login error:', error);
        this.errorMessage = 'An error occurred during login. Please try again.';
      }
    }
  }
  
  

  // Toggle password visibility
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
    //console.log("Password Visibility:", this.showPassword);
  }

  // Open dialog for organization selection

  OpenEntryDialog(organizations: any[], userType:number): void {
   
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '300px';
    dialogConfig.maxWidth = '90vw';
    this.isDialogOpen = true;
    // Pass the organization data to the dialog
    dialogConfig.data = {
      organizations: organizations
    };
  
    const dialogRef = this.matDialog.open(SelectOrganizationDialogComponent, dialogConfig);
  
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        if (result.status === true) {
          //console.log('Organization selected successfully.');       
          this.userDataService.setSelectedOrganization(result.organizationId);
          this.userDataService.setOrgId(result.organizationId);
         

          const selectedOrg = organizations.find(org => org.organizationId === result.organizationId);
           const roleId = selectedOrg?.roleId;
          if (roleId !== undefined && roleId !== null) {
            try {
              await this.userService.selectOrganizationSession(result.organizationId, roleId);

              const sessionResponse = await this.userService.getSessionTimeoutsByOrgRole(
                result.organizationId,
                roleId
              ).toPromise();

              
              // Check if sessionResponse is an object (not array)
              if (sessionResponse && 'timeout' in sessionResponse) {
                const timeout = sessionResponse.timeout;
                this.userDataService.setUserSessionTimeoutData(timeout);
                this.sessionTimeoutService.start(); // ✅ start tracking inactivity
              } else if (Array.isArray(sessionResponse) && sessionResponse.length > 0) {
                const timeout = sessionResponse[0].timeout;
                this.userDataService.setUserSessionTimeoutData(timeout);
                this.sessionTimeoutService.start(); // ✅ start tracking inactivity
              } else {
                console.warn('No session timeout data found for this role.');
              }
              
            } catch (err) {
              console.error('Error fetching session timeouts:', err);
            }
          }
          //this.router.navigate(['/node']);
          this.router.navigate(['/node']); // Redirect to /node if logged in
        } else if (result.status === false) {
        }
      }
    });
  }
  OpenWarningDialog(organizations: any[], resorgData: any): void {
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = '300px';
     dialogConfig.maxWidth = '90vw';
     this.isDialogOpen = true;
     // Pass the organization data to the dialog
     dialogConfig.data = { organizations }; 
   
     const dialogRef = this.matDialog.open(OrganizationWarningDialogComponent, dialogConfig);
   
     dialogRef.afterClosed().subscribe(result => {
       if (result) {

        this.userDataService.setUserSessionTimeoutData(15);
        this.sessionTimeoutService.start(); // ✅ start tracking inactivity
        
         if (result.status === true) {
          this.userDataService.setSelectedOrganization(0);
          this.organizationService.setSelectedOrganization('0');
          localStorage.setItem('selectedOrganizationId','0');
           this.router.navigate(['/settings/organization']); // Redirect to /node if logged in
         } else if (result.status === false) {
         }
       }
     });
   }
}
